import type { LifecycleAdapter } from "@lyteflo/utils";

export const createVisibilityLifecycleAdapter = (): LifecycleAdapter => {
  const fgCallbacks = new Set<() => void>();
  const bgCallbacks = new Set<() => void>();

  const handler = () => {
    if (document.hidden) {
      bgCallbacks.forEach((cb) => cb());
    } else {
      fgCallbacks.forEach((cb) => cb());
    }
  };

  document.addEventListener("visibilitychange", handler);

  return {
    onForeground: (cb) => {
      fgCallbacks.add(cb);
      return () => {
        fgCallbacks.delete(cb);
      };
    },
    onBackground: (cb) => {
      bgCallbacks.add(cb);
      return () => {
        bgCallbacks.delete(cb);
      };
    },
  };
};
